import { Reveal } from "./Reveal";

const stats = [
    { value: "17+", label: "Years serving Coimbatore" },
    { value: "12,000+", label: "Policies placed" },
    { value: "40+", label: "Insurer partners" },
    { value: "4,800+", label: "Claims assisted" },
];

export const Stats = () => (
    <section data-testid="stats-section" className="mx-auto max-w-7xl px-6 py-28 md:px-12">
        <div className="grid grid-cols-2 gap-y-16 lg:grid-cols-4">
            {stats.map((s, i) => (
                <Reveal key={s.label} delay={i * 0.08}>
                    <div data-testid={`stat-${i}`} className="border-l border-line pl-6 md:pl-10">
                        <span className="font-serif text-5xl font-light text-ink md:text-7xl">{s.value}</span>
                        <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-moss">{s.label}</p>
                    </div>
                </Reveal>
            ))}
        </div>
    </section>
);
